package com.anjuros.website.templates.template1.modules

import com.anjuros.website.templates.template1.util.ResKey




enum class Template1GalleryCategory(
    val text: ResKey
) {
    SERVICE1(ResKey.TEMPLATE1_SERVICE1_TITLE),
    SERVICE2(ResKey.TEMPLATE1_SERVICE2_TITLE),
    SERVICE3(ResKey.TEMPLATE1_SERVICE3_TITLE),
    SERVICE4(ResKey.TEMPLATE1_SERVICE4_TITLE),

}

data class Template1GalleryItem(
    val image: String,
    val category: Template1GalleryCategory
)

val template1GalleryItems = listOf(

    Template1GalleryItem(
        "template1_category1_1.jpeg",
        Template1GalleryCategory.SERVICE1
    ),
    Template1GalleryItem(
        "template1_category1_2.jpg",
        Template1GalleryCategory.SERVICE1
    ),
    Template1GalleryItem(
        "template1_category1_3.jpg",
        Template1GalleryCategory.SERVICE1
    ),
    Template1GalleryItem(
        "template1_category1_4.jpg",
        Template1GalleryCategory.SERVICE1
    ),
    Template1GalleryItem(
        "template1_category1_5.jpg",
        Template1GalleryCategory.SERVICE1
    ),
    Template1GalleryItem(
        "template1_category2_1.png",
        Template1GalleryCategory.SERVICE2
    ),
    Template1GalleryItem(
        "template1_category2_2.jpg",
        Template1GalleryCategory.SERVICE2
    ),
    Template1GalleryItem(
        "template1_category2_3.jpg",
        Template1GalleryCategory.SERVICE2
    ),

    Template1GalleryItem(
        "template1_category3_1.jpg",
        Template1GalleryCategory.SERVICE3
    ),
    Template1GalleryItem(
        "template1_category3_2.jpg",
        Template1GalleryCategory.SERVICE3
    ),
    Template1GalleryItem(
        "template1_category3_3.jpg",
        Template1GalleryCategory.SERVICE3
    ),

    Template1GalleryItem(
        "template1_category4_1.jpg",
        Template1GalleryCategory.SERVICE4
    ),
    Template1GalleryItem(
        "template1_category4_2.jpg",
        Template1GalleryCategory.SERVICE4
    ),
    Template1GalleryItem(
        "template1_category4_3.jpg",
        Template1GalleryCategory.SERVICE4
    ),
    Template1GalleryItem(
        "template1_category4_4.jpg",
        Template1GalleryCategory.SERVICE4
    ),
)